const hasUppercase = (value) => /[A-Z]/.test(value);
const hasLowercase = (value) => /[a-z]/.test(value);
const hasNumber = (value) => /[0-9]/.test(value);
const hasSpecialCharacter = (value) => /[!@#$%^&*(),.?":{}|<>_\-\\[\]/`~+=;]/.test(value);

export const getPasswordRules = (password, confirmation) => ([
  {
    key: 'length',
    label: 'Minimum 8 characters',
    passed: password.length >= 8
  },
  {
    key: 'uppercase',
    label: 'At least 1 uppercase letter',
    passed: hasUppercase(password)
  },
  {
    key: 'lowercase',
    label: 'At least 1 lowercase letter',
    passed: hasLowercase(password)
  },
  {
    key: 'number',
    label: 'At least 1 number',
    passed: hasNumber(password)
  },
  {
    key: 'special',
    label: 'At least 1 special character',
    passed: hasSpecialCharacter(password)
  },
  {
    key: 'match',
    label: 'Confirmation matches password',
    passed: Boolean(confirmation) && password === confirmation
  }
]);
